var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBinder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    width: 24,
    viewBox: "0 0 48 48"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeWidth: 4,
    fill: "none",
    stroke: "#272726",
    strokeLinejoin: "round",
    className: "binder_svg__nc-icon-wrapper"
  }, /*#__PURE__*/React.createElement("path", {
    "data-cap": "butt",
    d: "M42 38V2H10a4 4 0 00-4 4v36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42 46v-8H10a4 4 0 00-4 4v0a4 4 0 004 4h32zM12 38V10M19 13h16v10H19z"
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjQiIHdpZHRoPSIyNCIgdmlld0JveD0iMCAwIDQ4IDQ4Ij48dGl0bGU+Ym9vayAzOTwvdGl0bGU+PGcgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2Utd2lkdGg9IjQiIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzI3MjcyNiIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgY2xhc3M9Im5jLWljb24td3JhcHBlciI+PHBhdGggZGF0YS1jYXA9ImJ1dHQiIGQ9Ik00MiwzOFYySDEwQzcuNzkxLDIsNiwzLjc5MSw2LDZ2MzYiPjwvcGF0aD4gPHBhdGggZD0iTTQyLDQ2di04SDEwIGMtMi4yMDksMC00LDEuNzkxLTQsNHYwYzAsMi4yMDksMS43OTEsNCw0LDRINDJ6Ij48L3BhdGg+IDxsaW5lIHgxPSIxMiIgeTE9IjM4IiB4Mj0iMTIiIHkyPSIxMCI+PC9saW5lPiA8cmVjdCB4PSIxOSIgeT0iMTMiIHdpZHRoPSIxNiIgaGVpZ2h0PSIxMCIgc3Ryb2tlPSIjMjcyNzI2Ij48L3JlY3Q+PC9nPjwvc3ZnPg==";
export { SvgBinder as ReactComponent };